module.exports = __webpack_public_path__ + "img/camera.21282421.svg";